import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EventItemCreditType } from '../../../../shared/items/event-item-credit-type.model';
import { DtoBase, ObjectStateEnum } from '../../../../../shared/model/index';
import { CE_CreditType } from '../../../../../config/ceu/ce-credit-type.model';

@Component({
  selector: 'wl-event-item-credit-type-list',
  templateUrl: 'event-item-credit-type-list.component.html',
  styleUrls: ['event-item-credit-type-list.component.css'],
    standalone: false
})
export class EventItemCreditTypeListComponent implements OnInit {
  @Input() eventItemCreditTypes: EventItemCreditType[] = [];

  public _objectStateEnum: any = ObjectStateEnum;

  /**
   * constructor
   */
  public constructor() {
    this.eventItemCreditTypes = [];
  }

  /**
   * my initter
   */
  ngOnInit() {}

  /**
   * triggered by add button click
   */
  public handleAddClick(): void {
    let newEventItemCreditType = new EventItemCreditType();
    this.eventItemCreditTypes.push(newEventItemCreditType);
  }

  /**
   * triggered by remove button click
   * @param eventItemCreditType
   */
  public handleRemoveClick(eventItemCreditType: EventItemCreditType) {
    if (!eventItemCreditType) return;

    // if already added to db, then mark for delete, else remove from list
    if (eventItemCreditType.EventPriceCreditTypeId > 0) {
      eventItemCreditType.ObjectState = ObjectStateEnum.Deleted;
    } else {
      let index = this.eventItemCreditTypes.indexOf(eventItemCreditType);
      if (index >= 0) this.eventItemCreditTypes.splice(index, 1);
    }
  }

  /**
   * triggered by unremove button click
   * @param eventItemCreditType
   */
  public handleUnRemoveClick(eventItemCreditType: EventItemCreditType) {
    if (!eventItemCreditType) return;

    eventItemCreditType.ObjectState = ObjectStateEnum.Unchanged;
  }

  /**
   * triggered by changing of credit type dropdown. just used for copying the credit type name
   * @param eventItemCreditType
   * @param newCreditType
   */
  public handleCreditTypeChange(eventItemCreditType: EventItemCreditType, newCreditType: CE_CreditType) {
    eventItemCreditType.CreditType = newCreditType ? newCreditType.CECreditType : '';
  }
}
